import styled from 'styled-components';

import { control } from '../../styles/mixins';

const CustomInput = styled.input`
  ${control}
  width: ${({ width }) => `${width}%`};
`;

const CustomTextArea = styled.textarea`
  ${control}
  padding-top: 14px;
`;

/* Rótulo "recortado" na borda do campo. */
const Label = styled.label`
  background-color: var(--surface);
  transform: translateY(10px);
  align-self: flex-start;
  padding: 0 10px 0 8px;
  margin-left: 10px;
  color: var(--ink-soft);
  font-size: 1.3rem;
  font-weight: 600;
  z-index: 1;
`;

/* Envolve só o campo, para ancorar o olho na borda dele e não do rótulo.
   Mesmo comportamento do login: o ícone aparece no hover ou no foco, e fica
   visível enquanto a senha estiver à mostra. */
const PasswordField = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  :hover,
  :focus-within {
    svg {
      visibility: visible;
    }
  }

  input {
    padding-right: 4.8rem;
  }

  svg {
    position: absolute;
    right: 1.6rem;
    top: 50%;
    transform: translateY(-50%);
    visibility: ${({ showPassword }) => (showPassword ? 'visible' : 'hidden')};
    cursor: pointer;
    user-select: none;
    transition: opacity 0.2s;

    :hover {
      opacity: 0.8;
    }
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${({ width }) => `${width}%`};

  :focus-within {
    label {
      color: var(--accent);
    }
  }
`;

export { CustomInput, Label, InputContainer, CustomTextArea, PasswordField };
